import { AxiosResponse } from "axios";
import { Job } from "serviceshift-ui/shared/src/typings/job";
import provideHook from "@/lib/provideHook";
import { useStore } from "@/lib/vuex-composition";

export const usePhotoUpload = provideHook(() => {
  const store = useStore();

  async function upload(job, files: FileList) {
    const reservations = await createReservations(job, files);

    const allRequests: Array<Promise<AxiosResponse>> = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // some browsers require this for the file to be ready
      // some do not support it
      if (typeof file.bytes === "function") {
        await file.bytes();
      }

      const reservation = reservations[i];

      allRequests.push(
        store.dispatch("uploadS3Photo", {
          file,
          reservation
        })
      );
    }

    return Promise.all(allRequests);
  }

  async function createReservations(job: Job, files: FileList) {
    const extensions: string[] = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      extensions.push(file.name.split(".").pop()!);
    }

    const payload = {
      job,
      extensions
    };

    const response = await store.dispatch("reserveS3Photos", payload);
    return response.data;
  }

  return {
    upload
  };
});
